<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Info elements/other'
 * Name: 'Notifications'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=7680-5412&m=dev'
 */
import { useToast } from '../composables/use-toast.hook'
import ToastItem from './ToastItem.vue'

defineOptions({
  name: 'ToastProvider',
})

const { toasts, dismiss } = useToast()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="toasts.length"
      class="toast-provider"
    >
      <TransitionGroup
        name="toast"
        tag="div"
        class="toast-provider__list"
      >
        <ToastItem
          v-for="toast in toasts"
          :key="toast.id"
          :toast="toast"
          @dismiss="dismiss"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped src="../styles/_toast-provider.scss" />
